import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";
import { banglaTextFormat } from "@validations/HRM/employee/generalInfoValidation";
import { englishTextFormate } from "@validations/HRM/settings/validation";

export const SETTINGS_NAME = FORM_FIELDS.INVENTORY.SETTINGS.NAME;

// /^[\u0980-\u09FF\s]+$/

export const settingsNameValidationSchema = yup.object().shape({
  [SETTINGS_NAME.GROUP]: yup.string().required("Group is required"),

  [SETTINGS_NAME.BRAND]: yup.string().required("Brand is required"),

  [SETTINGS_NAME.NAME_BN]: yup
    .string()
    .required("Name (Bangla) is required")
    .matches(banglaTextFormat, "Please provide Name (In Bangla)  "),
  [SETTINGS_NAME.NAME_EN]: yup
    .string()
    .required("Name (English) is required")
    .matches(englishTextFormate, "Please provide name (In English)"),
  [SETTINGS_NAME.TYPE]: yup.string().required("Type is required"),
  [SETTINGS_NAME.INVENTORY_TYPE]: yup
    .string()
    .required("Inventory type is required"),
  [SETTINGS_NAME.DESCRIPTION]: yup.string().nullable(),
});

export type SettingsNameSchemaType = yup.InferType<
  typeof settingsNameValidationSchema
>;
